import { MakeCall } from 'ha/services/apiV2/createMakeCall';

import { Subscription } from './types/Subscriptions';

export default (makeCall: MakeCall) => (subId: string | number) =>
  makeCall<Subscription>(
    'POST',
    `/api/v2/billing/subscription/${subId}/reactivate`,
  );
